import { render, staticRenderFns } from "./RegionInputNew.vue?vue&type=template&id=c6c6225a"
import script from "./RegionInputNew.vue?vue&type=script&lang=ts"
export * from "./RegionInputNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6c6225a')) {
      api.createRecord('c6c6225a', component.options)
    } else {
      api.reload('c6c6225a', component.options)
    }
    module.hot.accept("./RegionInputNew.vue?vue&type=template&id=c6c6225a", function () {
      api.rerender('c6c6225a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/autocompleteMultiselects/RegionInputNew.vue"
export default component.exports